import { render, staticRenderFns } from "./ShareDetail.vue?vue&type=template&id=141b1eae&scoped=true"
import script from "./ShareDetail.vue?vue&type=script&lang=js"
export * from "./ShareDetail.vue?vue&type=script&lang=js"
import style0 from "./ShareDetail.vue?vue&type=style&index=0&id=141b1eae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141b1eae",
  null
  
)

export default component.exports